import { render, staticRenderFns } from "./BlockItem.vue?vue&type=template&id=06bf6816"
import script from "./BlockItem.vue?vue&type=script&lang=js"
export * from "./BlockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports